<template>
  <div :class="bem()">
    <GenericStructuredText
      :content="content.formVerificationRequiredText"
      copy-size="body-sm"
    />

    <StravaCodeSnippet
      v-if="code"
    />
  </div>
</template>

<script setup>
const bem = useBEM('StravaVerificationRequired')
const route = useRoute()

defineProps({
  content: {
    type: Object,
    default: () => {}
  }
})

const code = route.query.code
</script>

<style lang="postcss" scoped>
.StravaVerificationRequired {
  @apply text-sm text-center p-8
    flex flex-col gap-8;
}
</style>
